var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayButtonRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.1 30.1",
    style: {
      enableBackground: "new 0 0 30.1 30.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\tpath{fill:#E2001A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,14.4l-6.2-4.5c-0.2-0.2-0.5-0.2-0.8-0.1c-0.3,0.1-0.4,0.4-0.4,0.7v9.1c0,0.3,0.2,0.5,0.4,0.7 c0.1,0.1,0.2,0.1,0.3,0.1c0.2,0,0.3,0,0.4-0.1l6.2-4.5c0.2-0.1,0.3-0.4,0.3-0.6C20.3,14.8,20.2,14.6,20,14.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15,0C6.7,0,0,6.7,0,15s6.7,15,15,15s15-6.7,15-15C30.1,6.7,23.3,0,15,0z M15,27.5C8.1,27.5,2.5,21.9,2.5,15 S8.1,2.5,15,2.5S27.5,8.1,27.5,15S21.9,27.5,15,27.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButtonRed);
export default __webpack_public_path__ + "static/media/play-button-red.56b15a4be461b15e27bd9db2741413b5.svg";
export { ForwardRef as ReactComponent };